import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Icon from "../../../../icon";
import { TIME_ZONE_MESSAGE } from "../../../../../constants/external-constants";
import { ConfirmationNotificationModal } from "../../../modal/confirmation-modal.component";
import { CONFIRMATION_VALUE } from "../../../../../utils/constant.utils";
import Translation from "../../../translation/translation.component";
import { adminSettingActions } from "../../../../../store/admin-setting.reducer";
import { OR_RRF_Select as Select} from "../../../forms/order-request-form.component";
import CustomSearchableSelectWrapper from "../../../custom-form/custom-searchable-select-wrapper.component";
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';

class TimeZone extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showConModal: false,
            showOption: false,
            selectedTimeZoneId: 0
        };
        this.timeZoneRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = event => {
        if (this.state.showOption && this.timeZoneRef.current && !this.timeZoneRef.current.contains(event.target)) {
            this.setState({ showOption: false });
        }
    };

    handleShowModal = (key) => {
        this.setState({ showConModal: true, selectedTimeZoneId: key });
        this.props.handleModal(true);
    }

    handleShowOption() {
        this.setState(prev => ({ showOption: !prev.showOption }));
    }

    handleConfirmationModal = async (buttonType) => {
        if (buttonType === CONFIRMATION_VALUE.Ok) {

            this.props.saveTimeZone(this.state.selectedTimeZoneId)

            this.setState(prev => ({
                showConModal: !prev.showConModal,
            }));


        } else {
            this.setState({ showConModal: false });
        }
        this.setState({ selectedTimeZoneId: 0 });
        this.props.handleModal(false);
        window.location.reload()
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }
    render() {
       
        const { timeZoneOptions, activeTimeZone } = this.props.adminSetting
        
        return (
            <>
            <ConfirmationNotificationModal
                    show={this.state.showConModal}
                    message={
                        <>
                            {TIME_ZONE_MESSAGE.Message}
                            <br /> <br />
                            {TIME_ZONE_MESSAGE.SecondMessage}
                        </>
                    }
                    title="Default Date Format"
                    handleModal={this.handleConfirmationModal}
                    disabled={this.state.isSaving}
                    customClass={'comment-notification-modal confirm-modal-container'}
                    discardBtn={true}
            />
            <div ref={this.timeZoneRef} className="userprofile-references custom-dropdown-button-container margin-bottom-8">
                <div onClick={this.handleShowOption.bind(this)}>
                    <Icon
                        customClassName="calendar-days"
                        name="clock-icon"
                        labelValue={<Translation translationKey="time_zone" />}
                        size="19px"
                        containerClass="icon-container"
                    />
                </div>
                {
                    this.state.showOption &&
                    <div className="custom-dropdown-list time-zone-list">
                        <div>
                            <p className="title margin-bottom-20">
                                 {<Translation translationKey="select_time_zone" />}
                            </p>
                        </div>
                        <CustomSearchableSelectWrapper
                            options={timeZoneOptions || []}
                            selected={activeTimeZone}
                            requiredField={true}
                            onChange={(e) => this.handleShowModal(e)}
                            fieldProp='.time-zone'
                            tagName='circuitTypeID'
                            optionLabelKey={{
                                Key: 'Key',
                                Value: 'Value'
                                }}
                            maxLength={255}
                        />
                    </div>
                }                
            </div>
            </>
        );
    }
}

export default connect(
    state => {
        const { adminSetting, translation } = state;
        return {
            adminSetting
            ,...translation
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, adminSettingActions),
        dispatch
    )
)(TimeZone);